(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
	const toggleButton = document.getElementById('mobile-menu-toggle');
	const mobileMenu = document.getElementById('mobile-menu');

	if (toggleButton && mobileMenu) {
		toggleButton.addEventListener('click', function() {
			// Toggle visibility of the mobile menu
			mobileMenu.classList.toggle('hidden');

			// Check if menu is open
			const menuOpen = !mobileMenu.classList.contains('hidden');

			// Update accessibility state
			toggleButton.setAttribute('aria-expanded', menuOpen ? 'true' : 'false');

			// Prevent body scroll when menu is open
			document.body.classList.toggle('overflow-hidden', menuOpen);
		});
	}
});

  } catch(e) { console.error(e); }
})();
})();
